import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'kk',
  months: [
    'қаңтар',
    'ақпан',
    'наурыз',
    'сәуір',
    'мамыр',
    'маусым',
    'шілде',
    'тамыз',
    'қыркүйек',
    'қазан',
    'қараша',
    'желтоқсан',
  ],
  monthsShort: ['қаң', 'ақп', 'нау', 'сәу', 'мам', 'мау', 'шіл', 'там', 'қыр', 'қаз', 'қар', 'жел'],
  weekdays: ['Жексенбі', 'Дүйсенбі', 'Сейсенбі', 'Сәрсенбі', 'Бейсенбі', 'Жұма', 'Сенбі'],
  weekdaysMin: ['Ж', 'Д', 'С', 'С', 'Б', 'Ж', 'С'],
  weekdaysShort: ['Жек', 'Дүй', 'Сей', 'Сәр', 'Бей', 'Жұм', 'Сен'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm',
    lts: 'h:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM, YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM, YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd D MMMM, YYYY HH:mm',
    'LLLL-Y': 'dddd D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM, YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM, YYYY h:mm',
    'lll-Y': 'D MMM h:mm',
    llll: 'ddd D MMM, YYYY h:mm',
    'llll-Y': 'ddd D MMM, h:mm',
    'll-Y+w': 'D MMM, ddd',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'YYYY [ж]. D MMMM, HH:mm ([GMT]Z)',
  },
  past: {
    y: { one: '%s ж. бұрын', other: '%s ж. бұрын' },
    M: { one: '%s ай бұрын', other: '%s ай бұрын' },
    w: { one: '%s ап. бұрын', other: '%s ап. бұрын' },
    d: { one: '%s күн бұрын', other: '%s күн бұрын' },
    h: { one: '%s сағ. бұрын', other: '%s сағ. бұрын' },
    m: { one: '%s мин. бұрын', other: '%s мин. бұрын' },
    s: { one: '%s сек. бұрын', other: '%s сек. бұрын' },
  },
  future: {
    y: { one: '%s ж. кейін', other: '%s ж. кейін' },
    M: { one: '%s айдан кейін', other: '%s айдан кейін' },
    w: { one: '%s ап. кейін', other: '%s ап. кейін' },
    d: { one: '%s күннен кейін', other: '%s күннен кейін' },
    h: { one: '%s сағ. кейін', other: '%s сағ. кейін' },
    m: { one: '%s мин. кейін', other: '%s мин. кейін' },
    s: { one: '%s сек. кейін', other: '%s сек. кейін' },
  },
  abbr: {
    y: { one: '%s жыл', other: '%s жыл' },
    M: { one: '%s ай', other: '%s ай' },
    w: { one: '%s апта', other: '%s апта' },
    d: { one: '%s күн', other: '%s күн' },
    h: { one: '%s сағ.', other: '%s сағ.' },
    m: { one: '%s мин.', other: '%s мин.' },
    s: { one: '%s сек.', other: '%s сек.' },
  },
  justNow: 'жаңа ғана',
  yesterday: 'Кеше',
  today: 'Бүгін',
  tomorrow: 'Ертең',
  weekStart: 1,
};
const localeName: LocaleName = 'kk';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (): string => '',
};
